<template>
  <div>
    <appMeeting :is-new="false" />
  </div>
</template>

<script>
import appMeeting from "@/components/meetings/meeting/Meeting";

export default {
  components: {
    appMeeting,
  },
};
</script>
